import { useAuthStore } from "../store/authStore";
import { formatBytes } from "../utils/formatBytes";

export function useQuota() {
  const user = useAuthStore((s) => s.user);

  if (!user) {
    return { used: 0n, quota: 0n, percent: 0, usedStr: "0 B", quotaStr: "0 B" };
  }

  const used = BigInt(user.usedBytes);
  const quota = BigInt(user.quotaBytes);
  const percent = quota > 0n ? Number((used * 100n) / quota) : 0;

  return {
    used,
    quota,
    percent,
    usedStr: formatBytes(used),
    quotaStr: formatBytes(quota),
    remainingStr: formatBytes(quota - used),
  };
}
